<template>
    <div id="home">
        <div
            class="jumbotron rounded-0 text-center my-0"
            style="padding: 100px 0px; background-color: #1e1e1e"
        >
            <div class="container homepage">
                <h1 class="display-3 text-white">Welcome To The Wong Lab</h1>
                <p class="lead text-light" style="font-size: 1.5em">
                    The Wong Lab is dedicated to finding targets for cancer therapeutics, specifically Glioblastoma, the most common and devastating form of brain tumors. 
                </p>
                <hr class="my-4 bg-white" />
                <p class="lead text-light" style="font-size: 1.25em">
                    Our lab has discovered and characterized many novel and mutant/splice variant proteins such as EGFRvIII, Gab-1, and mLEEK. We utilize innovative technologies to develop new immunotherapies for cancer. Recently, we have applied these technologies to the study of SARS-CoV-2 (Covid-19). 
                </p>
                <p class="lead">
                    <scrollactive
                        :offset="80"
                        :duration="800"
                        bezier-easing-value=".5,0,.35,1"
                    >
                        <a
                            class="btn btn-primary btn-lg m-4 py-2 px-3 scrollactive-item"
                            href="#about"
                            role="button"
                        >
                            Learn More

                            <i class="far fa-arrow-alt-circle-down"></i>
                        </a>
                        <!-- <a
                            class="btn btn-success btn-lg m-3 scrollactive-item"
                            href="#contact"
                            role="button"
                            >Contact Us</a
                        > -->
                    </scrollactive>
                </p>

                <div
                    class="alert alert-success alert-dismissible fade show mx-auto d-inline-block text-left"
                    role="alert"
                >
                    <strong>Get In Touch</strong> Contact Us if you are
                    interested in working at The Wong Lab
                    <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <hr />
                    <scrollactive
                        :offset="80"
                        :duration="800"
                        bezier-easing-value=".5,0,.35,1"
                    >
                        <a class="btn btn-block btn-success scrollactive-item" href="#contact" role="button"
                            >Contact</a
                        >
                    </scrollactive>
                </div>

                <!-- <div class="alert alert-info" role="alert">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="alert-heading">Well done!</h4>
                    
                    <p>
                        Aww yeah, you successfully read this important alert
                        message. This example text is going to run a bit longer
                        so that you can see how spacing within an alert works
                        with this kind of content.
                    </p>
                    <hr />
                    <p class="mb-0">
                        Whenever you need to, be sure to use margin utilities to
                        keep things nice and tidy.
                    </p>
                    
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Home",
    mounted() {},
};
</script>

<style scoped>
.homepage {
}
</style>